import type { EvidencePackFilters } from '../../services/reportsApi';
import {
  DEFAULT_HAZARD_CLASS_KEY,
  type HazardClassKey,
  isHazardClassKey,
  parseSafetyReportTypeMode,
  type SafetyReportTypeMode,
} from '../acceptanceProof/hazardClassReportOptions';

export type SafetyReportEvidencePackScope = {
  fromIso: string;
  toIso: string;
  orgId: string;
  siteId: string;
  deviceId?: string;
  zoneId?: string;
  cameraIds: string[];
  policyType?: string;
  policyIds: string[];
  caseId?: string;
  incidentId?: string;
  reportTypeMode: SafetyReportTypeMode;
  hazardClassKey: HazardClassKey;
};

export function parseSafetyReportTypeFromSearchParams(
  searchParams: URLSearchParams,
): { reportTypeMode: SafetyReportTypeMode; hazardClassKey: HazardClassKey } {
  const reportTypeMode = parseSafetyReportTypeMode(searchParams.get('report_type'));
  const raw = String(searchParams.get('hazard_class') || '').trim().toLowerCase();
  const hazardClassKey = isHazardClassKey(raw) ? raw : DEFAULT_HAZARD_CLASS_KEY;
  return { reportTypeMode, hazardClassKey };
}

export function buildSafetyReportEvidencePackFilters(
  scope: SafetyReportEvidencePackScope,
): EvidencePackFilters {
  const hazardClassMode = scope.reportTypeMode === 'hazard_class';
  return {
    from_date: scope.fromIso,
    to_date: scope.toIso,
    org_id: scope.orgId,
    site_id: scope.siteId,
    device_id: scope.deviceId,
    zone_id: scope.zoneId,
    camera_ids: scope.cameraIds,
    policy_type: scope.policyType,
    policy_ids: scope.policyIds,
    case_id: hazardClassMode ? undefined : scope.caseId,
    incident_id: hazardClassMode ? undefined : scope.incidentId,
    hazard_class: hazardClassMode ? scope.hazardClassKey : undefined,
  };
}

export function safetyReportScopeCacheSegment(
  reportTypeMode: SafetyReportTypeMode,
  hazardClassKey: HazardClassKey,
): string {
  return reportTypeMode === 'hazard_class' ? `${reportTypeMode}|${hazardClassKey}` : reportTypeMode;
}
